import { CoreEvent, eventNames } from '@carvana/core-events';
import {
  useEffectWithController,
  usePromise
} from '@carvana/merch-react-hooks';
import { useContext, useEffect } from 'react';
import { useIsLoggedIn } from '~/context/common/UserContext';
import SavedSearchesContext from '~/context/srp/SavedSearchesContext';
import { SavedSearch } from '~/contracts/srp';
import { readSavedSearch } from '~/services/srp/savedSearch';
import { generateErrorLogger } from '~/utilities/loggers';

export default function useGetSavedSearches() {
  const mounted = usePromise();
  const {
    fetchSavedSearchTrigger,
    savedSearches: { setData, setLoaded, setLoading }
  } = useContext(SavedSearchesContext);
  const isLoggedIn = useIsLoggedIn();

  useEffect(() => {
    function updateSavedSearchData(payload) {
      if (payload.source === 'app' || !payload.searches) return;

      const dataForContext: SavedSearch[] = payload.searches.map(search => ({
        url: search.cvnaId,
        ...search
      }));

      setData(dataForContext);
    }

    CoreEvent.on(eventNames.favorites.mfe.refresh, updateSavedSearchData);

    return () => {
      CoreEvent.off(eventNames.favorites.mfe.refresh, updateSavedSearchData);
    };
  }, [setData]);

  useEffectWithController(
    controller => {
      if (!isLoggedIn) {
        setLoaded();

        return;
      }

      setLoading();

      mounted(readSavedSearch(controller))
        .then(({ data }) => {
          setData(data.savedSearches ?? []);
        })
        .catch(generateErrorLogger('SavedSearches', {}, { controller }));
    },
    [
      fetchSavedSearchTrigger,
      isLoggedIn,
      mounted,
      setData,
      setLoaded,
      setLoading
    ]
  );
}
